










































import Vue, { PropType } from 'vue';
import { OutlinedTextInput, AutoCompleteInput } from '@/components/ds';
import { integerNumberFormatter } from '@/helpers/number';
import Checkbox from '@/components/Checkbox.vue';

export interface InstitutionOption {
  key: string;
  value: string;
}

export interface SecondGraduationInstitutionInfoFormEvent {
  course?: string;
  graduationYear?: string;
  institution?: InstitutionOption;
  hasErrors: boolean;
  hasAcceptedToS: boolean;
}

export default Vue.extend({
  components: { OutlinedTextInput, AutoCompleteInput, Checkbox },
  props: {
    currentCourse: {
      type: String,
      default: '',
    },
    currentGraduationYear: {
      type: String,
      default: '',
    },
    currentInstitution: {
      type: Object as PropType<InstitutionOption>,
      default: () => ({} as any),
    },
    availableInstitutions: {
      type: Array as PropType<InstitutionOption[]>,
      required: true,
    },
    fallbackInstitution: {
      type: Object as PropType<InstitutionOption>,
      default: () => ({} as any),
    },
    tosAccepted: {
      type: Boolean,
      default: false,
    },
    userName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      course: this.currentCourse,
      graduationYear: this.currentGraduationYear,
      institution: this.currentInstitution,
      numberFormatter: integerNumberFormatter,
      errors: {
        graduationYear: false,
      },
      hasAcceptedToS: false,
      tosLink: process.env.VUE_APP_DESCOMPLICA_TOS_LINK,
    };
  },
  methods: {
    inputHandler() {
      const gradYearNumber = Number(this.graduationYear);
      const currentYear = new Date().getFullYear();
      this.errors.graduationYear = gradYearNumber < 1900 || gradYearNumber > currentYear;

      const event: SecondGraduationInstitutionInfoFormEvent = {
        course: this.course,
        graduationYear: this.graduationYear,
        institution: this.institution,
        hasErrors: this.errors.graduationYear,
        hasAcceptedToS: this.hasAcceptedToS,
      };

      this.$emit('input', event);
    },
    selectedHandler(selected: InstitutionOption) {
      this.institution = selected;
      this.inputHandler();
    },
    autoCompleteInputHandler(input: string) {
      this.$emit('search', input);
    },
    checkboxChangeHandler(event: any) {
      this.hasAcceptedToS = event.target.checked;
      this.inputHandler();
    },
  },
});
